import { jsx, jsxs } from "react/jsx-runtime";
import Checkbox from "@ingka/checkbox";
import cx from "classnames";
const CheckboxGroup = (props) => {
  const {
    className,
    subtle = false,
    list,
    prefix = "",
    name,
    ...other
  } = props;
  const classes = cx(`${prefix}checkbox-group`, className);
  return /* @__PURE__ */ jsxs("fieldset", { className: classes, role: "group", ...other, children: [
    name && /* @__PURE__ */ jsx("legend", { children: name }),
    list.map((item, i) => {
      return /* @__PURE__ */ jsx(Checkbox, { prefix, ...item, subtle }, i);
    })
  ] });
};
var CheckboxGroup_default = CheckboxGroup;
export {
  CheckboxGroup_default as default
};
